import React from 'react';
import {View, ViewProps} from 'react-native';

import platformConfig from '/config/platform.config';

interface AccessibilityWrapperProps extends ViewProps {}

export const AccessibilityWrapper: React.FC<AccessibilityWrapperProps> = ({
  children,
  ...props
}) => {
  const wrapper = platformConfig.select({
    ios: <View {...props}>{children}</View>, // iOS accessibility handled by RN
    android: <View {...props}>{children}</View>, // Android accessibility handled by RN
    web: <View {...props}>{children}</View>, // Web accessibility handled by browser
  });

  return wrapper || null;
};
